<div class="alert" [ngClass]="alertClass()" @newAlertAnimation role="status">
    <ng-icon class="alert__icon" [name]="alertIcon(alert)" size="20"/>
    <div class="alert__text">
        <strong>{{ alert.message.title }}</strong>
        <span>{{ alert.message.content }}</span>
    </div>
    <button type="button" class="icon-action" title="Close" (click)="removeAlert()">
        <ng-icon name="heroXMark" size="18"/>
    </button>
</div>
